import { defaultFor } from "common";
import { Culture } from "common/culture/supported-cultures";
import { getCopiedLabels, getCopiedName } from "common/functions/labels";
import { Dashboard } from "common/types/dashboards";
import { DashboardFormType } from "./form/types";

export const initialValue = defaultFor<DashboardFormType>();

export const unwrap = (form: DashboardFormType): Dashboard => form?.item;

export const wrap = (
  form: DashboardFormType,
  db: Dashboard,
): DashboardFormType => ({
  ...form,
  item: db,
});

const defaultDashboard = (userId: string): Dashboard => ({
  id: undefined,
  label: undefined,
  widgets: [],
  userId,
  labels: undefined,
  isGlobal: false,
});

export const getDefaultDashboard = (
  id: number,
  dbs: Dashboard[],
  userId: string,
): Dashboard => dbs.find((c) => c.id === id) || defaultDashboard(userId);

export const getTitle = (value: DashboardFormType) => value?.item?.label;

export const prepareDashboardForCopy = (
  dashboard: Dashboard,
  culture: Culture,
): Dashboard => ({
  ...dashboard,
  id: undefined,
  label: dashboard.label ? getCopiedName(dashboard.label) : undefined,
  labels: getCopiedLabels(dashboard.labels, culture),
});
